export default {
  example: 'English',
  example2: 'im ok',
}
